import { DateHelper } from './../../../utils/date-helper';
import { TimeHelper } from './../../../utils/time-helper';
import { PlanShared } from './../../general/shared/plan-shared';
import { Component, Input, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { EditFastingStartTimeBottomsheetComponent } from '../edit-fasting-start-time-bottomsheet/edit-fasting-start-time-bottomsheet.component';

@Component({
  selector: 'app-plan-overview-fasting-chart',
  templateUrl: './plan-overview-fasting-chart.component.html',
  styleUrls: ['./plan-overview-fasting-chart.component.scss'],
})
export class PlanOverviewFastingChartComponent implements OnInit {
  @Input() title: string;
  @Input() type: string;
  @Input() isFasting: boolean;
  @Input() duration?: number;
  @Input() endTime?: number;
  @Input() fastingTime?: number;
  @Input() fastingDays?: number[];
  @Input() dietStartDate?: number;
  @Input() dietId?: string;
  @Input() dataIsReady: boolean;
  @Input() set change(data: boolean) {
    if (data) {
      console.log('update');
      setTimeout(() => {
        this.initial();
      }, 30);
    }
  }
  counter = 0;
  percentage = 0;
  spentTime = '';
  startTimeTitle = '';
  startTimeTitle2 = '';
  endTimeTitle = '';

  isBeforeStart = [false, false, false, false, false, false, false];
  days = ['شنبه', '۱شنبه', '۲شنبه', '۳شنبه', '۴شنبه', '۵شنبه', 'جمعه'];
  dayOfWeek = 0;

  public doughnutChartLabels: string[] = [];
  public demodoughnutChartData1: number[][] = [[1, 0]];
  public chartColors1: any[] = [
    {
      backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
      borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
    },
  ];
  public demodoughnutChartData2: number[][] = [[1, 0]];
  public chartColors2: any[] = [
    {
      backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
      borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
    },
  ];
  public doughnutChartType = 'doughnut';
  public options = {
    responsive: false,
    maintainAspectRatio: false,
    cutoutPercentage: 92,
  };

  constructor(
    private planShared: PlanShared,
    private timeHelper: TimeHelper,
    private dateHelper: DateHelper,
    private matBottomSheet: MatBottomSheet
  ) {}

  ngOnInit() {}

  initial() {
    console.log(this.type);

    if (this.type === 'hourly') {
      while (this.endTime < new Date().getTime()) {
        this.endTime += 24 * 60 * 60 * 1000;
      }
      const startTime = this.endTime - this.duration * 60 * 60 * 1000;
      this.counter = new Date().getTime() - startTime;
      this.spentTime = this.timeHelper.getTimeStringByMiliseconds(
        this.counter,
        true
      );
      if (this.isFasting) {
        this.demodoughnutChartData1 = [
          [this.counter, this.duration * 60 * 60 * 1000 - this.counter],
        ];
        this.demodoughnutChartData2 = [[0, 1]];
        this.percentage = Math.floor(
          (100 * this.counter) / (this.duration * 60 * 60 * 1000)
        );
      } else {
        this.demodoughnutChartData1 = [[1, 0]];
        this.demodoughnutChartData2 = [
          [this.counter, this.duration * 60 * 60 * 1000 - this.counter],
        ];
      }
      this.chartColors1 = [
        {
          backgroundColor: ['#ffbc25', 'rgba(0,0,0,0)'],
          borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
        },
      ];
      this.chartColors2 = [
        {
          backgroundColor: ['#0073ff', 'rgba(0,0,0,0)'],
          borderColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
        },
      ];

      this.startTimeTitle =
        (new Date(this.fastingTime).getHours() < 10
          ? '۰' + new Date(this.fastingTime).getHours()
          : new Date(this.fastingTime).getHours()) +
        ':' +
        (new Date(this.fastingTime).getMinutes() < 10
          ? '۰' + new Date(this.fastingTime).getMinutes()
          : new Date(this.fastingTime).getMinutes()) +
        ' , ';
      this.startTimeTitle2 =
        (new Date(this.fastingTime).getHours() < 10
          ? '۰' + new Date(this.fastingTime).getHours()
          : new Date(this.fastingTime).getHours()) +
        ':' +
        (new Date(this.fastingTime).getMinutes() < 10
          ? '۰' + new Date(this.fastingTime).getMinutes()
          : new Date(this.fastingTime).getMinutes()) +
        ' ';
      if (this.dateHelper.isSameDay(new Date(), new Date(this.fastingTime))) {
        this.startTimeTitle += 'امروز';
        this.startTimeTitle2 += 'امروز';
      } else if (new Date().getTime() > this.fastingTime) {
        this.startTimeTitle += 'دیروز';
        this.startTimeTitle2 += 'دیروز';
      } else {
        this.startTimeTitle += 'فردا';
        this.startTimeTitle2 += 'فردا';
      }
      const fastingEndTime =
        this.fastingTime +
        (this.isFasting
          ? this.duration * 60 * 60 * 1000
          : (24 - this.duration) * 60 * 60 * 1000);
      this.endTimeTitle =
        (new Date(fastingEndTime).getHours() < 10
          ? '۰' + new Date(fastingEndTime).getHours()
          : new Date(fastingEndTime).getHours()) +
        ':' +
        (new Date(fastingEndTime).getMinutes() < 10
          ? '۰' + new Date(fastingEndTime).getMinutes()
          : new Date(fastingEndTime).getMinutes()) +
        ' , ';
      if (this.dateHelper.isSameDay(new Date(), new Date(fastingEndTime))) {
        this.endTimeTitle += 'امروز';
      } else if (new Date().getTime() > fastingEndTime) {
        this.endTimeTitle += 'دیروز';
      } else {
        this.endTimeTitle += 'فردا';
      }

      setTimeout(() => {
        this.hourlyTimer();
      }, 1000);
    } else if (this.type === 'daily') {
      this.dayOfWeek = new Date().getDay() + 2;
      this.dayOfWeek = this.dayOfWeek === 8 ? 1 : this.dayOfWeek;

      const date = new Date().setHours(0, 0, 0, 1);
      for (let i = this.dayOfWeek - 1; i >= 0; i--) {
        console.log(this.dietStartDate, i, date - i * 24 * 60 * 60 * 1000);
        if (this.dietStartDate > date - i * 24 * 60 * 60 * 1000) {
          this.isBeforeStart[this.dayOfWeek - 1 - i] = true;
        }
      }
    }
  }

  hourlyTimer() {
    this.counter += 1000;
    if (this.counter >= this.duration * 60 * 60 * 1000) {
      this.planShared.refreshDiet();
    } else {
      if (this.isFasting) {
        this.demodoughnutChartData1 = [
          [this.counter, this.duration * 60 * 60 * 1000 - this.counter],
        ];
        this.demodoughnutChartData2 = [[0, 1]];
        this.percentage = Math.floor(
          (100 * this.counter) / (this.duration * 60 * 60 * 1000)
        );
      } else {
        this.demodoughnutChartData1 = [[1, 0]];
        this.demodoughnutChartData2 = [
          [this.counter, this.duration * 60 * 60 * 1000 - this.counter],
        ];
      }
      this.spentTime = this.timeHelper.getTimeStringByMiliseconds(
        this.counter,
        true
      );
      setTimeout(() => {
        this.hourlyTimer();
      }, 1000);
    }
  }

  editFastingStartTime() {
    const bottomSheetRef = this.matBottomSheet.open(
      EditFastingStartTimeBottomsheetComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: {
          title: this.title,
          startTime: this.fastingTime,
          dietId: this.dietId,
        },
      }
    );
    const sub = bottomSheetRef.afterDismissed().subscribe((dataFromChild) => {
      if (dataFromChild.needRefresh) {
        this.planShared.refreshDiet();
      }
      sub.unsubscribe();
    });
  }

  changeTab() {
    this.planShared.showFirstTab();
  }
}
